/** Pending background uploads within this window may PATCH without strict version pre-check. */
export const CHAPTER_BACKGROUND_LENIENT_SYNC_MS = 4 * 60 * 60 * 1000
